// 发票申请列表
<template>
  <div class="threeLevelMain">
      <!-- 查询区域 -->
      <div class="queryBox clearfix">
          <div class="query_row">
              <div class="scan_box">
                  <span class="sp_scan">发票类型：</span>
                  <el-select v-model="queryFormList.type" placeholder="全部" class="ip_scan" size="mini">
                    <el-option label="专票" value="1"></el-option>
                    <el-option label="普票" value="2"></el-option>
                    <el-option label="形式发票" value="3"></el-option>
                  </el-select>
              </div>
              <div class="scan_box">
                  <span class="sp_scan">是否为提前开票：</span>
                  <el-select v-model="queryFormList.state" placeholder="全部" class="ip_scan" size="mini">
                    <el-option label="否" value="0"></el-option>
                    <el-option label="是" value="1"></el-option>
                  </el-select>
              </div>
              <div class="scan_box">
                  <span class="sp_scan">金额筛选：</span>
                  <div class="amount">
                    <el-input v-model="queryFormList.money_state" class="ip_scan" size="mini"></el-input>
                    <span style="margin:0 10px;">~</span>
                    <el-input v-model="queryFormList.money_end" class="ip_scan" size="mini"></el-input>
                  </div>
              </div>
              <div class="scan_box">
                  <span class="sp_scan">购买方发票抬头：</span>
                  <el-input v-model="queryFormList.buy_invoice_title" size="mini" class="ip_scan"></el-input>
              </div>
              <!-- 按钮区域 -->
              <div class="btn_box">
                <el-button 
                type="primary" 
                size="mini" 
                style="margin-left:20px;"
                @click="searchBtn">查询</el-button>

                <el-button 
                type="primary" 
                size="mini" 
                style="margin-left:20px;"
                @click="resetSearch">重置</el-button>
              </div>
          </div>
      </div>

      <!-- 内容区域 -->
      <tablePageComp
      :columnsList="columnsList"
      :dataList="dataList"
      :getDataConfig="dataQueryFunc()"
      :updateDataTag="updateDataTag"
      :totalCount="totalCount"
      v-loading="loading"
      >
        <el-table-column
            slot="add_time"
            width="100"
            label="日期"
            align="center"
        >
            <template slot-scope="scope">
                <div>{{scope.row.add_time.split(" ")[0]}}</div>
            </template>
        </el-table-column>
        <el-table-column
            slot="is_renewal"
            width="80"
            label="新签/续签"
            align="center"
        >
            <template slot-scope="scope">
                <div v-if="scope.row.is_renewal == 0" class="fontColor_success">新签</div>
                <div v-else class="fontColor_theme">续签</div>
            </template>
        </el-table-column>
        <el-table-column
            slot="c_id"
            width="150"
            label="客户名称"
            align="center"
        >
            <template slot-scope="scope">
                <div>{{scope.row.c_name}}</div>
            </template>
        </el-table-column>
        <el-table-column
            slot="invoice_title"
            width="110"
            label="销售方发票抬头"
            align="center"
        >
            <template slot-scope="scope">
                <div>{{scope.row.invoice_title}}</div>
            </template>
        </el-table-column>
        <el-table-column
            slot="type"
            width="90"
            label="专票/普票"
            align="center"
        >
            <template slot-scope="scope">
                <div v-if="scope.row.type == 1" class="fontColor_success">专票</div>
                <div v-else-if="scope.row.type == 2" class="fontColor_theme">普票</div>
                <div v-else-if="scope.row.type == 3" class="fontColor_warning">形式发票</div>
            </template>
        </el-table-column>
        <el-table-column
            slot="state"
            width="90"
            label="是否为提前开票"
            align="center"
        >
            <template slot-scope="scope">
                <div v-if="scope.row.state == 0" class="fontColor_success">否</div>
                <div v-else-if="scope.row.state == 1" class="fontColor_theme">是</div>
            </template>
        </el-table-column>
        <el-table-column
            slot="order_time"
            width="90"
            label="到单时间"
            align="center"
        >
            <template slot-scope="scope">
                <div>{{scope.row.order_time.split(" ")[0]}}</div>
            </template>
        </el-table-column>
        <el-table-column
            slot="billing_time"
            width="100"
            label="财务开票时间"
            align="center"
        >
            <template slot-scope="scope">
                <div>{{scope.row.billing_time ? scope.row.billing_time.split(" ")[0] : ''}}</div>
            </template>
        </el-table-column>
        <el-table-column
            slot="mailing_time"
            width="90"
            label="邮寄时间"
            align="center"
        >
            <template slot-scope="scope">
                <div>{{scope.row.mailing_time ? scope.row.mailing_time.split(" ")[0] : ''}}</div>
            </template>
        </el-table-column>
        <el-table-column
            slot="cw_handle"
            width="100"
            label="财务操作"
            align="center"
            fixed="right"
            v-if="department == 2 || department == 7"
        >
            <template slot-scope="scope">
                <div>
                    <el-button type="primary" size="mini" plain @click="openDialog(scope.row)">财务操作</el-button>
                </div>
            </template>
        </el-table-column>
        <el-table-column
            slot="sc_handle"
            width="100"
            label="市场操作"
            align="center"
            fixed="right"
            v-if="department == 3 || department == 7"
        >
            <template slot-scope="scope">
                <div>
                    <el-button type="warning" size="mini" plain @click="openDialog(scope.row)">市场操作</el-button>
                </div>
            </template>
        </el-table-column>
        <el-table-column
            slot="revise_handle"
            width="100"
            label="修改操作"
            align="center"
            fixed="right"
            v-if="department != 3 && department != 2"
        >
            <template slot-scope="scope">
                <div>
                    <el-button type="primary" size="mini" plain @click="openDialog(scope.row)">修改</el-button>
                </div>
            </template>
        </el-table-column>
      </tablePageComp>

      <!-- 弹窗 -->
    <el-dialog
    title="发票信息修改"
    :visible.sync="dialogVisible"
    width="40%"
    :before-close="dialogClose"
    >
        <!-- 财务操作 -->
        <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm" v-if="department == 2 || department == 7">
            <el-form-item label="财务开票时间">
                <el-date-picker
                v-model="ruleForm.billing_time"
                type="date"
                placeholder="选择开票日期"
                value-format="yyyy-MM-dd">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="发票号码">
                <el-input v-model="ruleForm.invoice_number"></el-input>
            </el-form-item>
            <el-form-item label="批注">
                <el-input v-model="ruleForm.comments"></el-input>
            </el-form-item>
            <!-- 按钮区域 -->
            <el-form-item>
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
            </el-form-item>
        </el-form>

        <!-- 市场操作 -->
        <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm" v-if="department == 3 || department == 7">
            <el-form-item label="邮寄时间">
                <el-date-picker
                v-model="ruleForm.mailing_time"
                type="date"
                placeholder="选择邮寄日期"
                value-format="yyyy-MM-dd">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="邮寄费用">
                <el-input v-model="ruleForm.mailing_fee"></el-input>
            </el-form-item>
            <el-form-item label="快递公司">
                <el-input v-model="ruleForm.express"></el-input>
            </el-form-item>
            <el-form-item label="快递单号">
                <el-input v-model="ruleForm.courier_number"></el-input>
            </el-form-item>
            <!-- 按钮区域 -->
            <el-form-item>
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
            </el-form-item>
        </el-form>

        <!-- 如果不是市场部或财务部，展示修改按钮 -->
        <InvoiceApply v-if="department != 2 && department != 3" :reviseFormData="reviseFormData" className="formItems2" ></InvoiceApply>
    </el-dialog>

  </div>
</template>

<script>
import api from '@/api'
import utils from '@/libs/utils.js'
import InvoiceApply from '@/components/workOrder/invoiceApplyOrder.vue'
export default {
components:{
    InvoiceApply,
},
data() {
    let userId = utils.sessionGetStore('user_id')
    return {
        userId:userId,
        // 列表查询条件
        queryFormList:{
            type:'', // 发票类型
            state:'',// 是否为提前开票
            money_state:'',// 金额筛选start
            money_end:'',// 筛选 end
            buy_invoice_title:'',// 购买方发票抬头
            id:userId,//当前登录人id
        },
        // 表格内容相关
        loading: false,
        dataList:[],
        isCriteriaQuery:false,
        updateDataTag:false,
        totalCount:0,// 数据总条数
        columnsList:[
            {
                label:"日期",
                slotName:"add_time",
            },
            {
                label:"新签/续签",
                slotName:'is_renewal'
            },
            {
                label:"客户名称",
                slotName:"c_id"
            },
            {
                label:"销售方发票抬头",
                slotName:"invoice_title"
            },
            {
                label:"专票/普票",
                slotName:"type"
            },
            {
                label:"开票金额",
                prop:"money"
            },
            {
                label:"购买方发票抬头",
                prop:"buy_invoice_title"
            },
            {
                label:"税号",
                prop:"paragraph"
            },
            {
                label:"注册地址和电话",
                prop:"address_and_telephone"
            },
            {
                label:"银行名称和账号",
                prop:"bank_and_account"
            },
            {
                label:"销售姓名",
                prop:"sale_id"
            },
            {
                label:"是否为提前开票",
                slotName:"state"
            },
            {
                label:"到单时间",
                slotName:"order_time"
            },
            {
                label:"收件人",
                prop:"addressee"
            },
            {
                label:"联系方式",
                prop:"contact_information",
                width:"100"
            },
            {
                label:"地址",
                prop:"address",
                width:"110"
            },
            {
                label:"批注",
                prop:"comments",
                width:"100"
            },
            {
                label:"财务开票时间",
                slotName:"billing_time",
            },
            {
                label:"发票号码",
                prop:"invoice_number",
                width:'120'
            },
            {
                label:"邮寄时间",
                slotName:"mailing_time"
            },
            {
                label:"邮寄费用",
                prop:"mailing_fee"
            },
            {
                label:"快递公司",
                prop:"express"
            },
            {
                label:"快递单号",
                prop:"courier_number",
                width:"120"
            },
            {
                label:"财务操作",
                slotName:"cw_handle"
            },
            {
                label:"市场操作",
                slotName:"sc_handle"
            },
            {
                label:"修改操作",
                slotName:"revise_handle"
            },

        ],

        // 弹窗相关
        dialogVisible: false,
        // 市场和财务操作表单信息
        ruleForm:{
            // 信息修改表单
            comments:'',// 批注
            billing_time:'',//财务开票时间
            invoice_number:'',//发票号码
            mailing_time:'',//邮寄时间
            mailing_fee:'',//邮寄费用
            express:'',//快递公司
            courier_number:'',//快递单号
        },
        // 修改发票信息表单
        reviseFormData:{
            invoice_title:'',//销售方发票抬头
            type:'',// 发票类型
            money:'',// 开票金额
            buy_invoice_title:'',// 购买方发票抬头
            paragraph:'',// 税号
            address_and_telephone:'',// 注册地址和电话
            bank_and_account:'',// 银行名称和账号
            state:'',// 是否为提前开票
            order_time:'',// 到单时间
            addressee:'',// 收件人
            contact_information:'',// 联系方式
            address:'',// 地址
            is_renewal: '0',// 是否续签（0 否 1是） 
            c_id:'',// 客户ID
            c_name:'',// 客户名称
        },

        department:'',// 部门
    }
},
mounted() {
    // 获取当前登录人所在部门
    this.department = JSON.parse(utils.sessionGetStore('department'))
    // console.log(this.department)
},
methods:{

// 查询部分
  //带条件查询，查询按钮事件
  searchBtn(){
    // 将查询条件存入本地
    utils.sessionSetStore('invoiceSearch',this.queryFormList)
      
    // 是否带条件查询---更新
    this.isCriteriaQuery = true
    // 主动更新数据标记---更新，子组件调用获取数据方法
    this.updateDataTag = !this.updateDataTag

  },
  
  //重置查询
  resetSearch(){
      this.queryFormList = {
            type:'', // 发票类型
            state:'',// 是否为提前开票
            money_state:'',// 金额筛选start
            money_end:'',// 筛选 end
            buy_invoice_title:'',// 购买方发票抬头
        },

    // 清除本地查询条件
    utils.sessionRemoveStore('invoiceSearch')

    // 是否带条件查询---更新
    this.isCriteriaQuery = false
    // 主动更新数据标记---更新，子组件调用获取数据方法
    this.updateDataTag = !this.updateDataTag
  },

  //表格数据获取
  dataQueryFunc(){
      //查询条件
      let paramObj = this.queryFormList

      //判断是否是默认查询
      if(this.isCriteriaQuery){
          
      }
        
      //传递给表格组件，在表格组件中取数据，进行其他操作
    return {
        apiName:'getInvoiceDataList',
        paramObj:paramObj,
        success: function (response, callBack) {
            // console.log(response)
            let records = response.data.data.list
            let arr = []
            for (let i = 0; i < records.length; i++) {
                let obj = records[i]
                //全部表头 和接口返回字段一一对应
                let standardObj = {
                    // "corporate_name": "公司名称",
                    
                }
                for (let key in standardObj) {
                  if (obj[key] == null || obj[key] == undefined) {
                      obj[key] = ''
                  }
                }

                
                arr.push(obj)
            }
            // console.log(records)
            // 数据列表---更新
            this.dataList = arr
            // console.log('工单列表',this.dataList)
            // 数据总条数---更新
            this.totalCount = response.data.data.totalCount//接口返回的数据总条数

            // 回调函数
            if (callBack) {
                callBack()
            }
        }.bind(this),
        failed: function (error, callBack) {
            // 回调函数
            if (callBack) {
                callBack()
            }
        }
    }
  },

//  弹窗添加信息
openDialog(data){
    this.dialogVisible = true

    // 市场或财务添加信息
    if(this.department == 2 || this.department == 3){
        Object.keys(this.ruleForm).forEach(item => {
            this.ruleForm[item] = data[item] == null || data[item] == 'null' ? '' : data[item]
        })
        this.ruleForm.id = data.id
    } else {
        // 其他部门修改发票第一部分内容
        Object.keys(this.reviseFormData).forEach(item => {
            this.reviseFormData[item] = data[item] == null || data[item] == 'null' ? '' : data[item]
        })
        this.reviseFormData.contact_information = Number(data.contact_information)
        this.reviseFormData.id = data.id

    }
    
},

// 确认提交信息----财务或市场部提交
submitForm(formName){
    this.$refs[formName].validate((valid) => {
        if(valid) {
            let paramObj = this.ruleForm
            api.reviseInvoiceList(paramObj)
            .then(res => {
                // console.log(res)
                this.updateDataTag = !this.updateDataTag
                this.dialogVisible = false
                utils.notificationInfo('提示','提交成功','success')
            })
            .catch(error => {
                console.log(error)
                utils.notificationInfo('提示','提交失败','error')
            })
        } else {
            utils.notificationInfo('提示','填写信息有误','error')
            return false;
        }
    })
},
dialogClose(done) {
    this.$confirm('确认关闭？')
        .then(_ => {
        done();
        })
        .catch(_ => {});
},
},
}
</script>

<style lang="scss" scoped>
.threeLevelMain{
    .queryBox{
        margin-bottom:2px;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;

        // 金额筛选
        .amount{
            display: flex;
            align-items: center;
            justify-content: center;
            >div{margin:0!important;}
        }
    }
}
</style>